import MigrationPending from '@/components/ui/MigrationPending'

export default function ShippedVsPendingOrdersReport() {
  return <MigrationPending title="Shipped vs Pending Orders" subtitle="Report — migration to new stack pending" />
}

ShippedVsPendingOrdersReport.layout = MigrationPending.layout
